import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarMisFacturas, type FacturasParams } from "../services/facturas.api";

/**
 * Listado paginado de "Mis facturas" · filtros por columna, orden y página
 * van al server como query params (forman parte del queryKey · refetch al
 * cambiar). `keepPreviousData` evita el parpadeo mientras llega la página
 * filtrada. Polling suave para reflejar acuses que pasan de "En proceso"
 * a su estatus final cuando responde el SAT.
 */
export const misFacturasQueryOptions = (params: FacturasParams = {}) =>
  queryOptions({
    queryKey: qk.misFacturas(params),
    queryFn: () => listarMisFacturas(params),
    refetchInterval: 10_000,
    staleTime: 0,
    placeholderData: keepPreviousData,
  });

export function useMisFacturas(params: FacturasParams = {}) {
  return useQuery(misFacturasQueryOptions(params));
}
